import axios from 'axios';
import { setupInterceptors } from './authInterceptor';

const api3004 = axios.create({
    baseURL: process.env.REACT_APP_API_3004_URL,
});

setupInterceptors(api3004);

export default api3004;
